import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../assets/logo23.png";
import { Link } from "react-router-dom";

const ReachUs = () => {
  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    // Close mobile navbar after click
    const navLinks = document.getElementById("navLinks");
    if (navLinks.classList.contains("show")) {
      const navbarToggler = document.querySelector(".navbar-toggler");
      navbarToggler.click();
    }
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const response = await fetch(
        "https://guftagu-landing-service-backend-576610474197.asia-south1.run.app/contact/reachus/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setStatus("Message sent successfully!");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        const errorData = await response.json();
        console.error("Error:", errorData);
        setStatus("Failed to send message.");
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus("An error occurred while sending.");
    }
  };

  return (
    <>
      <div className="container mt-4">
        <nav
          className="navbar navbar-expand-lg px-4 py-1 custom-navbar"
          style={{
            backgroundColor: "#030712",
            border: "1px solid rgba(255,255,255,0.2)",
            borderRadius: "12px",
          }}
        >
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src={logo}
              alt="logo"
              style={{ width: "18%", height: "16%" }}
            />{" "}
            <span className="ms-2 fw-bold text-light brand-text">gupsy</span>
          </a>

          <button
            className="navbar-toggler text-white"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navLinks"
            aria-controls="navLinks"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div
            className="collapse navbar-collapse justify-content-end"
            id="navLinks"
          >
            <ul className="navbar-nav gap-lg-4 text-center">
              <li className="nav-item">
                <Link to="/" className="nav-link btn text-white">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/" className="nav-link btn text-white">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/" className="nav-link btn text-white">
                  Pre-Register
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      {/*  */}
      <div className="text-light" style={{ marginTop: "10%" }}>
        <h2 className="text-center fw-bold" style={{ fontSize: "480%" }}>
          Get In Touch
        </h2>
        <p className="text-center text mb-4">
          Have questions about our AI Companion app or trouble using it? Fill
          out the form below and our team will reach out to you shortly.
        </p>
        <hr />

        <div className="container-fluid text-light p-4 rounded shadow-sm">
          <div className="row g-4">
            <div className="col-lg-5">
              <h3 className="mb-4">Contact Information</h3>

              <div className="d-flex mb-3">
                <i className="bi bi-envelope-fill text-info fs-5 me-3"></i>
                <div>
                  <p className="fw-semibold mb-1">Email</p>
                  <p className="text-light mb-0">info@neomonkstech.com</p>
                  <p className="text-light"> sarvraj.singh@neomonkstech.com </p>
                </div>
              </div>

              <div className="d-flex mb-3">
                <i className="bi bi-telephone-fill text-success fs-5 me-3"></i>
                <div>
                  <p className="fw-semibold mb-1">Phone</p>
                  <p className="text-light">+91-9354170215</p>
                </div>
              </div>

              <div className="d-flex mb-3">
                <i className="bi bi-clock text-danger fs-5 me-3"></i>
                <div>
                  <p className="fw-semibold mb-1">Response Time</p>
                  <p className="text-light">
                    We typically respond within 24 hours
                  </p>
                </div>
              </div>

              <div className="map-container rounded shadow-sm overflow-hidden">
                <iframe
                  title="Our Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3499.049709339209!2d77.25831459999999!3d28.7180604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd0060fab2d9%3A0x382c7d68ee6225ad!2sNeomonks%20Tech%20Private%20Limited!5e0!3m2!1sen!2sin!4v1759580958665!5m2!1sen!2sin"
                  width="50%"
                  height="150"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>

            </div>

            <div className="col-lg-7">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your full name"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Subject</label>
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Add Subject.."
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Query??..."
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-danger w-100">
                  Send Message
                </button>

                {status && <p className="text-center mt-3">{status}</p>}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReachUs;
